var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-absolute tw-right-0 tw-top-0 tw-z-50"},[_c('IconButton',{on:{"click":function (e) { return _vm.$emit('click', e); }}},[_c('CloseIcon',{staticClass:"tw-text-[#111827] tw-text-xl"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }